import React from "react";

export default function Instagram(props: any) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6083 6.98089L15.2423 4.34692M16.7474 2.8418L15.2423 4.34692L16.7474 2.8418ZM9.51532 10.0739C9.9039 10.4573 10.2128 10.9138 10.4242 11.4171C10.6357 11.9204 10.7455 12.4605 10.7473 13.0064C10.7491 13.5523 10.6429 14.0931 10.4349 14.5978C10.2268 15.1025 9.92099 15.561 9.53499 15.947C9.14899 16.333 8.69045 16.6389 8.18577 16.8469C7.68109 17.055 7.14023 17.1611 6.59435 17.1593C6.04847 17.1575 5.50833 17.0477 5.00506 16.8363C4.50178 16.6248 4.0453 16.3159 3.66189 15.9273C2.90792 15.1467 2.49073 14.1012 2.50016 13.0159C2.50959 11.9306 2.94489 10.8925 3.71231 10.1251C4.47973 9.35767 5.51787 8.92236 6.60312 8.91293C7.68838 8.9035 8.73392 9.3207 9.51457 10.0747L9.51532 10.0739ZM9.51532 10.0739L12.6083 6.98089L9.51532 10.0739ZM12.6083 6.98089L14.866 9.23857L17.5 6.60461L15.2423 4.34692L12.6083 6.98089Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
}